"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "roccaverano": {
    "cd6726af": [{
      "hkey": "1ece791e",
      "slug": "roccaverano",
      "name": "Roccaverano",
      "primary": true,
      "skipSearch": false
    }],
    "garbeoli": [{
      "hkey": "1ece791e",
      "slug": "roccaverano",
      "name": "Roccaverano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f862c9c4": [{
      "hkey": "1ece791e",
      "slug": "roccaverano",
      "name": "Roccaverano",
      "primary": true,
      "skipSearch": false
    }],
    "ourano": [{
      "hkey": "1ece791e",
      "slug": "roccaverano",
      "name": "Roccaverano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "db5e468b": [{
      "hkey": "1ece791e",
      "slug": "roccaverano",
      "name": "Roccaverano",
      "primary": true,
      "skipSearch": false
    }],
    "san-gerolamo": [{
      "hkey": "1ece791e",
      "slug": "roccaverano",
      "name": "Roccaverano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a0490bae": [{
      "hkey": "1ece791e",
      "slug": "roccaverano",
      "name": "Roccaverano",
      "primary": true,
      "skipSearch": false
    }],
    "san-giovanni": [{
      "hkey": "1ece791e",
      "slug": "roccaverano",
      "name": "Roccaverano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5a4a1f65": [{
      "hkey": "1ece791e",
      "slug": "roccaverano",
      "name": "Roccaverano",
      "primary": true,
      "skipSearch": false
    }],
    "tassito": [{
      "hkey": "1ece791e",
      "slug": "roccaverano",
      "name": "Roccaverano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ce6313a7": [{
      "hkey": "1ece791e",
      "slug": "roccaverano",
      "name": "Roccaverano",
      "primary": true,
      "skipSearch": false
    }],
    "vengore": [{
      "hkey": "1ece791e",
      "slug": "roccaverano",
      "name": "Roccaverano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;